export enum WidthType {
  PIXEL = 'PIXEL',
  PERCENTAGE = 'PERCENTAGE',
  COLSPAN = 'COLSPAN',
  FULL_WIDTH = 'FULL_WIDTH',
  FIXED = 'FIXED',
}
